import { Component, Input, OnChanges } from '@angular/core';
import { ChartConfiguration, ChartData } from 'chart.js';
import { TempDataPoint } from '../version.service';

@Component({
  selector: 'app-sparkline-chart',
  template: `
    <div [style.height]="expanded ? 'clamp(80px,25vw,120px)' : '44px'" style="position:relative;">
      <canvas baseChart
        [data]="chartData"
        [options]="chartOptions"
        type="line">
      </canvas>
    </div>
  `,
})
export class SparklineChartComponent implements OnChanges {
  @Input() points: TempDataPoint[] = [];
  @Input() darkMode = false;
  @Input() expanded = false;

  chartData: ChartData<'line'> = { datasets: [] };
  chartOptions: ChartConfiguration<'line'>['options'] = {};

  ngOnChanges(): void {
    const textColor  = this.darkMode ? 'rgba(255,255,255,0.6)' : 'rgba(0,0,0,0.6)';
    const gridColor  = this.darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)';

    this.chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      animation: false,
      plugins: {
        legend: { display: false },
        tooltip: {
          callbacks: {
            title: (items) => {
              const ts = items[0]?.parsed.x;
              return ts != null
                ? new Date(ts).toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' })
                : '';
            },
            label: (item) => ` ${(item.parsed.y ?? 0).toFixed(1)} °C`,
          },
        },
      },
      scales: {
        x: {
          display: this.expanded,
          type: 'linear',
          min: Date.now() - 24 * 3600 * 1000,
          max: Date.now(),
          ticks: {
            color: textColor,
            maxTicksLimit: 3,
            callback: (val) => {
              const diff = Date.now() - (val as number);
              const h24  = 24 * 3600 * 1000;
              const h12  = 12 * 3600 * 1000;
              if (diff < 5 * 60 * 1000)                    return 'Jetzt';
              if (Math.abs(diff - h12) < 30 * 60 * 1000)  return '–12h';
              if (Math.abs(diff - h24) < 30 * 60 * 1000)  return '–24h';
              return null;
            },
          },
          grid: { display: this.expanded, color: gridColor },
        },
        y: {
          display: this.expanded,
          ticks: {
            color: textColor,
            callback: (val) => `${val}°`,
          },
          grid: { color: gridColor },
        },
      },
      elements: {
        point: { radius: 0, hoverRadius: 4 },
        line:  { borderWidth: this.expanded ? 2 : 1.5, tension: 0.6 },
      },
    };

    this.chartData = {
      datasets: [{
        data: this.points.map(p => ({ x: p.ts, y: p.tempC })),
        borderColor: '#0d6efd',
        backgroundColor: 'transparent',
        fill: false,
      }],
    };
  }
}
